import React, { useState } from 'react';
import Results from "./Results";
import {Link, useSearchParams} from "react-router-dom";


function AllResults() {

    const [searchParams] = useSearchParams();
    const url = searchParams.get('u') || '';
    const yearPart = url.indexOf('_') > 0 ? url.split('_')[1] : url;

    const [year, setYear] = useState(yearPart);
    const [path, setPath] = useState(url);

    const now = new Date();
    let startYear = now.getFullYear();
    if (now.getMonth() < 4) {
        // don't print current year until May.
        startYear--;
    }


    const years = [];
    for (let y= startYear; y>=2013; y--) {
        years.push(y);
    }

    const oldYears = [];
    const names = ['dummy', 'Halvmara tävling män', 'Halvmara tävling kvinnor', 'Halvmara motion', '10 km motion', '5 km motion', 'Stavgång 5 km'];

    for (let y=2012; y>=2007; y--) {
        const year = {'year': y, 'classes': []};
        for (let i= 1; i<=6; i++) {
            const cClass = {};
            cClass.name = names[i];
            if (y === 2008) {
                cClass.name = names[i].replace('5', '6');
            }
            cClass.year = y;
            cClass.url = i+'_'+y;
            year.classes.push(cClass);
        }
        oldYears.push(year);
    }


    const printYear = () => {
        const u = year > 2012 ? '/resultatlistor/resultatlista_'+path+'.html' :
            '/resultatlistor/'+year+'/resultatlista_'+path+'.html'
        return (

            <div>
                <Link className="nounderline" to={''} onClick={() => {
                    setPath('')
                    setYear('')
                }}>⬅️</Link>
                <Results url={process.env.PUBLIC_URL + u} />

            </div>

        );
    }

    const printRef = (year, url, text) => {
        if (year == '2020' || year == '2021')
            return '';
        return (
            <Link to={'?u='+url} onClick={() => {
                setPath(url)
                setYear(year)
            }}>{text}</Link>
        );
    }

    if (year) {
        return printYear();
    }

    return (

        <div>
            <h1>Resultatlistor för Kanallöpet</h1>
            {years.map(y => (<section key={y}> {printRef(y, y, (<h3>Resultat {y} </h3>))}</section>))}

            {oldYears.map(y => (
                <section key={y.year}>
                    <h3>Resultat {y.year}</h3>
                    {
                        y.classes.map(c => (<section key={c.url}> {printRef(c.year, c.url, c.name)} &nbsp;</section>))
                    }

                </section>
            ))};

            <h3>Resultat 2006</h3>
            {printRef(2006, '21dm_2006', 'DM 21 km')} &nbsp;
            {printRef(2006, '21tavling_2006', 'Halvmara tävling kvinnor/2006/män')} &nbsp;
            {printRef(2006, '21km_2006', 'Halvmara motion')} &nbsp;
            {printRef(2006, '10km_2006', '10 km motion')} &nbsp;
            {printRef(2006, '5km_2006', '5 km motion')} &nbsp;

            <h3>Resultat 2005</h3>
            {printRef(2005, '3_2005', 'Halvmara motion')} &nbsp;
            {printRef(2005, '4_2005', '10 km motion')} &nbsp;
            {printRef(2005, '5_2005', '5 km motion')} &nbsp;

        </div>
    );
}

export default AllResults;